import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { ModalContext } from '../context/modal';
import * as CONSTANTS from '../constants';

const GlobalStyle = createGlobalStyle`
  .legal {
    max-width: 800px;
    margin: 0 auto;
    padding: 0 30px 15px 30px;
  }

  .legal h1 {
    text-align: center;
    margin-top: 30px;
    padding: 0 30px;
    font-size: 24px;
    font-weight: 200;
    position: relative;
    display: table;
    margin: 30px auto 0 auto;
    ${props => (props.darkMode === true) ? `color: ${CONSTANTS.darkModeWhite}`
    : ''};
  }

  .legal h2 {
    font-size: 18px;
    margin: 30px 0 5px 0;
    font-weight: 200;
    ${props => (props.darkMode === true) ? `color: ${CONSTANTS.darkModeWhite}`
    : ''};
  }

  .legal p {
    font-size: 16px;
    color: ${props => (props.darkMode === true) ? `${CONSTANTS.darkModeNiceGray}`
    : `${CONSTANTS.darkGray}`};
  }

  .legal p:first-of-type {
    font-size: 12px;
    padding: 15px 0 10px 0;
    font-weight: 200;
    ${props => (props.darkMode === true) ? `color: ${CONSTANTS.darkModeWhite}`
    : ''};
  }

  .legal p a, .basic-cta {
    font-weight: 200;
    ${props => (props.darkMode === true) ? 'color: #717171;border-bottom: 1px solid #717171;'
    : ''};
  }
  
  .legal p a:hover, .basic-cta:hover {
    ${props => (props.darkMode === true) ? 'color: #444;border-color: #444;'
    : 'color: ${CONSTANTS.mediumGray}'};
  }
`;

export default class LegalText extends React.Component {
  render() {
    return (
      <React.Fragment>
        <GlobalStyle darkMode={this.context.darkMode} />
        <div className="legal" dangerouslySetInnerHTML={{__html: this.props.content}} />
      </React.Fragment>
    );
  }
}

LegalText.contextType = ModalContext;
